import React from 'react'
import { MEMBERS } from '../../../config/actionTypes'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import { connect } from 'react-redux'
import ContactMailIcon from '@mui/icons-material/ContactMail'
import EmailIcon from '@mui/icons-material/Email'
import MailboxIcon from '@mui/icons-material/MarkunreadMailbox'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'

export const iconColorSelector =  {
    both: 'darkgreen',
    email: 'green',
    contact: 'red',
    noMail: 'darkred'
}

const ContactTypeFilter = ({ applyValue, item, dispatch, contactTypeFilter}) => {
 
  const contactTypes = {
    mailDelivery: {icon: <EmailIcon style={{color: iconColorSelector.email}}/>, value: 'email', title: 'E-Mail'},
    mailDeliveryCR:{ icon: <ContactMailIcon style={{color: iconColorSelector.contact}}/>, value: 'contact', title: ' An Kontakt'},
    deliveryBoth: {icon: <><EmailIcon style={{color: iconColorSelector.both}} /><ContactMailIcon style={{color: 'green'}} /></>, value: 'both', title: 'An beide'},
    noMail: {icon: <MailboxIcon style={{color: iconColorSelector.noMail}}/>, value: 'noMail', title: 'Postweg'}
  }

  const handleFilterChange = (e) => {
        dispatch({type: MEMBERS.FILTER_SET_AVTIVE_CONTACT_TYPE, payload: e.target.value})
        return applyValue({...item, value: e.target.value})
  }

  return (
    <TextField
      id='contactType-filter-select'
      select
      label='Kontakt Type'
      onChange={handleFilterChange}
      value={contactTypeFilter}
    >
      {Object.values(contactTypes).map((item, i)=>{
        const addDivider = i!==Object.values(contactTypes).length-1
              return <MenuItem divider={addDivider} dense key={i} value={item.value}>
                <ListItemIcon >{item.icon}</ListItemIcon>
                <ListItemText >{item.title}</ListItemText>
              </MenuItem>
        })}
    </TextField>
  )
}

const ContactTypeFilterConected = connect((state) => {
  return ({
  contactTypeFilter: state.members.contactTypeFilter,
})})(ContactTypeFilter)

export const contactTypeFilterOperators = [
  {
    label: 'gleich',
    value: 'equals',
    getApplyFilterFn: (filterItem) => {
      if (
        !filterItem.columnField ||
        !filterItem.value ||
        !filterItem.operatorValue
      ) {
        return null;
      }

      return (params) =>{
        return filterItem.value===params.value
      }
    },
    InputComponent: ContactTypeFilterConected,
 
  },
]

export default contactTypeFilterOperators

